import { useRef, useState } from "react";

const Tooltip = ({ title, placement = "top", children }) => {
  const wrapperRef = useRef(null);
  const [style, setStyle] = useState({});
  const [visible, setVisible] = useState(false);

  const show = () => {
    if (!wrapperRef.current) return;
    const rect = wrapperRef.current.getBoundingClientRect();
    const gap = 8;
    let top, left;

    if (placement === "top" || placement === "start") {
      top = rect.top - gap;
      left = rect.left + rect.width / 2;
    } else if (placement === "bottom") {
      top = rect.bottom + gap;
      left = rect.left + rect.width / 2;
    } else if (placement === "left") {
      top = rect.top + rect.height / 2;
      left = rect.left - gap;
    } else if (placement === "right" || placement === "end") {
      top = rect.top + rect.height / 2;
      left = rect.right + gap;
    } else {
      top = rect.top - gap;
      left = rect.left + rect.width / 2;
    }

    setStyle({ top, left });
    setVisible(true);
  };

  const hide = () => setVisible(false);

  const normalizedPlacement =
    { top: "top", bottom: "bottom", left: "left", right: "right", start: "top", end: "right" }[placement] || "top";

  return (
    <span
      className="customTooltipWrapper d-inline-block"
      ref={wrapperRef}
      onMouseEnter={show}
      onMouseLeave={hide}
      onFocus={show}
      onBlur={hide}
    >
      <span className="customTooltipTarget d-inline-flex">{children}</span>
      {title && visible ? (
        <span
          className={`customTooltip ${normalizedPlacement} customTooltipFixed`}
          role="tooltip"
          style={style}
        >
          {title}
          <span className="customTooltipArrow" aria-hidden="true" />
        </span>
      ) : null}
    </span>
  );
};

export default Tooltip;
